import { render } from "./CompanyTasks.vue?vue&type=template&id=457fa1f2"
import script from "./CompanyTasks.vue?vue&type=script&lang=js"
export * from "./CompanyTasks.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__